//
export default [
    {
        name: 'period',
        type: 'date-field',
        props: {
            label: 'Periodo',
            pickerProps: {
            	type: 'month',
            },
        },
    },
]
